/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} My_Payments_Order_PaidInputs */

const en_my_payments_order_paid = /** @type {(inputs: My_Payments_Order_PaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paid`)
};

const pl_my_payments_order_paid = /** @type {(inputs: My_Payments_Order_PaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opłacone`)
};

/**
* | output |
* | --- |
* | "Paid" |
*
* @param {My_Payments_Order_PaidInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const my_payments_order_paid = /** @type {((inputs?: My_Payments_Order_PaidInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Payments_Order_PaidInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_my_payments_order_paid(inputs)
	return en_my_payments_order_paid(inputs)
});